module.exports = __webpack_public_path__ + "static/img/A117.443a04bf.jpg";